import { render, staticRenderFns } from "./TestsEdit.vue?vue&type=template&id=398487a9&scoped=true&"
import script from "./TestsEdit.vue?vue&type=script&lang=js&"
export * from "./TestsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398487a9",
  null
  
)

export default component.exports